import cls from 'classnames'
import { h, FunctionComponent, Fragment } from 'preact'
import { useContext } from 'preact/hooks'

import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'
import classes from './description.scss'

type Props = {
  minDescription: string | null
  maxDescription: string | null
}

const Description: FunctionComponent<Props> = (props) => {
  const { minDescription = '', maxDescription = '' } = props
  const { windowSizeSm } = useContext(FieldsContext)!
  const hasRatingDescription = minDescription || maxDescription

  return (
    <Fragment>
      {hasRatingDescription && (
        <div className={cls(classes.description, windowSizeSm && classes.sm)}>
          <span>{minDescription}</span>
          <span>{maxDescription}</span>
        </div>
      )}
    </Fragment>
  )
}

export default Description
